import React, { memo } from 'react';

interface HeadBtnProps {
  headBtnType: number;
  setCurrent: (val: number) => void;
  setModelShow: (val: boolean) => void;
  handleCancel: () => void;
}

function LoginHeadBtn(props: HeadBtnProps) {
  const { headBtnType, setCurrent, setModelShow, handleCancel } = props;

  const onCurrent = () => {
    setCurrent(0);
  };
  const onGoBack = () => {
    handleCancel();
    setModelShow(false);
  };
  return (
    <div className="login_header_box">
      <div className="login_header_box-operation_box">
        {headBtnType === 0 || headBtnType === 3 ? (
          <span></span>
        ) : (
          <span
            className="operation_back"
            onClick={e => {
              e.stopPropagation();
              onCurrent();
            }}
          ></span>
        )}
        {headBtnType !== 1 ? (
          <div className="newDeviceModal-box_title">{headBtnType !== 2 ? '登录提示' : '原设备授权登录'}</div>
        ) : (
          <div className="newDeviceModal-box_title">手机验证码验证</div>
        )}
        {headBtnType !== 0 ? (
          <span
            className="operation_close"
            onClick={() => {
              onGoBack();
            }}
          ></span>
        ) : (
          <span></span>
        )}
      </div>
    </div>
  );
}
export default memo(LoginHeadBtn);
